import React, { useState, useRef, useEffect } from 'react';

const AlbumShareResult = ({ shareUrl }) => {
  const [copied, setCopied] = useState(false);
  const linkRef = useRef(null);

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  const copyToClipboard = () => {
    if (linkRef.current) {
      navigator.clipboard.writeText(linkRef.current.value)
        .then(() => {
          setCopied(true);
        })
        .catch(err => {
          console.error('Failed to copy: ', err);
        });
    }
  };

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
      <div className="flex items-center mb-3">
        <div className="h-10 w-10 rounded-full bg-green-100 flex-shrink-0 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-lg font-bold text-green-800">Public Link Created!</h3>
          <p className="text-sm text-green-700">Your album is now shareable with anyone using this link</p>
        </div>
      </div>
      
      <div className="bg-white rounded-lg p-4 border border-green-200">
        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="share-link">
          Shareable Link
        </label>
        <div className="flex">
          <input
            ref={linkRef}
            id="share-link"
            type="text"
            value={shareUrl}
            readOnly
            className="flex-grow px-3 py-2 rounded-l-md border-r-0 border border-gray-300 focus:ring-purple-500 focus:border-purple-500"
          />
          <button
            onClick={copyToClipboard}
            className={`px-4 py-2 ${copied ? 'bg-green-600' : 'bg-purple-600 hover:bg-purple-700'} text-white rounded-r-md focus:outline-none`}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      </div>
      
      <div className="mt-4 text-sm">
        <p className="flex items-start">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>Anyone can view your photos using this link, but they'll need to create an account to download them.</span>
        </p>
      </div>
    </div>
  );
};

export default AlbumShareResult;